import DatePicker from "react-datepicker"
import { IMaskInput } from 'react-imask'
import React, { Component } from 'react'
import {connect} from "react-redux"
import moment from 'moment';
import _ from "lodash"

import { setFieldData,addObject,removeLastObject,removeObjectAt } from './fieldsSlice';
import validators from './fieldsValidator';
import { getQuote,quoteIfCan } from '../quote/quoteSlice';

import "./stylesheet/datapicker.scss"

import { v4 as uuidv4 } from 'uuid';

class Fields extends Component {
  constructor(props){
    super(props);
    this.loopthroughfields = this.loopthroughfields.bind(this);
    this.inputChange = this.inputChange.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.validate = this.validate.bind(this);
    this.validateAll = this.validateAll.bind(this);
    this.addObject = this.addObject.bind(this);
    this.removeObject = this.removeObject.bind(this);

    this.years = [];
    this.inputValues = [];
    this.progressInput = [];
    this.validateInputs = [];

    if(typeof this.props.list !== "undefined"){
      this.list = _.map(this.props.list,(o)=>{
        if(o.field.length > 5)
          o.field = _.chain(o.field).split("_").map((o) => { if(o.length === 5) return `${o}.values`;else if(!isNaN(parseFloat(o)) && isFinite(o)) return parseInt(o)-1; else return o;}).join(".").value();
        return o
      }
      ,[])
    }
 
    var currentYear = new Date().getFullYear();
    for(var y = currentYear;y > currentYear - 99; y--){
      this.years.push(y);
    }
    this.needUiUpdate = true;
    
    
  }
  validateAll(){
    var allValues = Object.values(this.validateInputs);
    var allKeys = Object.keys(this.validateInputs);
    var errors = false;

    for(var i = 0; i < allValues.length; i++){

      var path = allKeys[i];
      var value = allValues[i].value;
      var field = allValues[i].field;
      
      if(this.validate(path,value,field))
        errors = true;

    }
    this.props.onSubmit(!errors)
  }
  validate(path,value,field){
    if(field.hasOwnProperty("validators")){
      var errors =  field.validators.map(validator => validators[validator](value,field)).filter(element => element !== undefined);
      var fieldElem = document.querySelector(`#${path.replaceAll(".","-")}`);
      var fieldErrorElem = document.querySelector(`#${path.replaceAll(".","-")}>.field-errors`);
     
      if(errors.length > 0){
        fieldErrorElem.innerHTML = errors.map(o=>`<span>${o}</span>`).join("");
        fieldElem.classList.add("error-in-field");
      }else{
        fieldErrorElem.innerHTML = "";
        fieldElem.classList.remove("error-in-field");
      }
      return (errors.length > 0);
    }
  }
  validateInput(path,value,needUiUpdate,field){
    if(this.validate(path,value,field))
      return;
    if(typeof field.validators !== "undefined")
      this.progressInput[path] = true;
    this.inputChange(path,value,needUiUpdate)
    
  }
  inputChange(field,value,needUiUpdate){
    this.needUiUpdate = needUiUpdate;
    this.props.setField({path:field,value:value})
    this.validateInputs[field].value = value;
    if(typeof this.props.onProgress !== "undefined")
      this.props.onProgress(this.progressInput);
  }
  addObject(object){
    this.needUiUpdate = true;
    this.props.addObject(object)
  }
  removeObject(object,index){
    this.needUiUpdate = true;
    this.props.removeObjectAt(object,index);
    this.props.quoteIfCan();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
  }
  loopthroughfields(fields,uri = ""){

    var results = [];
    var self = this;
    for(const field in fields){
      
      var indexInList =  (typeof this.props.list !== "undefined")?_.findIndex(this.list,(o) => {return (o.field).includes(uri + field) || (uri + field).includes(o.field)}):0;
      if (indexInList !== -1 || typeof this.list === "undefined"){
        
        if(typeof fields[field] === 'object' && field !== "model"){
          
          if(fields[field].hasOwnProperty("type")){

            if(fields[field].type !== "hidden" && fields[field].type !== "group"){
                
              var input = null;
            
              switch(fields[field].type){
    
                case "text": 
    
                  this.inputValues[(uri + field).replaceAll(".","_")] = ""
                  input = (fields[field].hasOwnProperty("mask"))?(
                    <IMaskInput
                      mask={fields[field].mask}
                      value={(fields[field].value.length > 0) ? fields[field].value:null}
                      unmask={true}
                      autoComplete="nope"  
                      onAccept={(value,mask)=>{
                        this.inputValues[(uri + field).replaceAll(".","_")] = value;
                      }}
                      onBlur={
                        (e) => {this.validateInput(uri + field,this.inputValues[(uri + field).replaceAll(".","_")],(typeof fields[field].uiUpdate !== "undefined")?fields[field].uiUpdate:false,fields[field])}
                      }
                  />
                  ):
                  (<input autoComplete="nope" key={uuidv4()} type="text" defaultValue={(fields[field].value.length > 0) ? fields[field].value:""} onBlur={(e)=>this.validateInput(uri + field,e.target.value,(typeof fields[field].uiUpdate !== "undefined")?fields[field].uiUpdate:false,fields[field])} disabled={(fields[field].enabled === false)?true:false}/>)
                  break;
                
                case "checkbox":
    
                  input = (
                    <label>
                      <input autoComplete="nope" key={uuidv4()} type="checkbox" defaultChecked={(fields[field].value.length > 0) && fields[field].value} onChange={(e)=>{this.validateInput(uri + field,(!e.target.checked)?"":"true",(typeof fields[field].uiUpdate !== "undefined")?fields[field].uiUpdate:false,fields[field]);}} disabled={(fields[field].enabled === false)?true:false}/>
                      <span dangerouslySetInnerHTML={{__html: fields[field].text}}></span>
                    </label>
                  )
                  break;
                
                case "select":
    
                  input = (
                  <select autoComplete="nope" key={uuidv4()} type="text" defaultValue={(fields[field].value.length > 0) ? fields[field].value:0} onChange={(e)=>this.validateInput(uri + field,e.target.value,(typeof fields[field].uiUpdate !== "undefined")?fields[field].uiUpdate:false,fields[field])} disabled={(fields[field].enabled === false)?true:false}>
                    <option key={uuidv4()} value="0"  disabled></option>
                    {(fields[field].hasOwnProperty("options") && _.map(fields[field].options,(elem) => (<option key={uuidv4()} value={elem.value}>{elem.name}</option>)))}
                  </select>)
                  break;
    
                case "date": 
    
                  input = (<div className="field-calendar">
                    {(fields[field].monthsEnabled === false)?(
                    <select autoComplete="nope" key={uuidv4()} type="text" defaultValue={(fields[field].value.length > 0) ? fields[field].value:0} onChange={(e)=>this.validateInput(uri + field,e.target.value,(typeof fields[field].uiUpdate !== "undefined")?fields[field].uiUpdate:false,fields[field])} disabled={(fields[field].enabled === false)?true:false}>
                      <option key={uuidv4()} value="0"  disabled>Select Year</option>
                      {_.map(this.years,(elem)=>(<option key={uuidv4()} value={elem}>{elem}</option>))}
                    </select>
                    ):
                    <DatePicker
                      selected={(fields[field].value.length > 0) ? moment(fields[field].value,"YYYYMMDD").toDate():null}
                      onSelect={(date) => {this.validateInput(uri + field,moment(date).format("YYYYMMDD"),(typeof fields[field].uiUpdate !== "undefined")?fields[field].uiUpdate:false,fields[field])}}
                      maxDate={new Date()} 
                      dateFormat="MM/yyyy"   
                      showMonthYearPicker 
                      inline
                      renderCustomHeader={({
                        date,
                        changeYear,
                        increaseYear,
                        decreaseYear,
                        prevYearButtonDisabled,
                        nextYearButtonDisabled,
                      }) => (
                        <div
                          style={{
                            margin: "0px 10px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <button className="datepicker-yearNavButton" onClick={decreaseYear} disabled={prevYearButtonDisabled}>
                            {"<"}
                          </button>
                          <select
                            className="datepicker-yearSelection"
                            value={moment(date).format("YYYY")}
                            onChange={({ target: { value } }) => changeYear(value)}
                          >
                            {self.years.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                
                          <button className="datepicker-yearNavButton" onClick={increaseYear} disabled={nextYearButtonDisabled}>
                            {">"}
                          </button>
                        </div>
                      )}
                    />
                    }
                  </div>)
                  break;
    
                case "object":
                  var objectFields = []
                  var nestedObject = this.loopthroughfields(fields[field],uri+`${field}.`);
                  if (nestedObject.length > 0) objectFields.push(nestedObject);
                  input = _.flattenDeep(objectFields)
                  break;
    
                default:
                  break;
    
              }
              var inNotSingle = (typeof this.props.list !== "undefined" && typeof this.props.list[indexInList].single !== "undefined")?!this.props.list[indexInList].single:true;

              if(fields[field].type === "object" && inNotSingle){

                
                input = (<div key={uuidv4()} className="field-group" id={(uri + field).replaceAll(".","-")} order={indexInList}><div key={uuidv4()} className='field-title' dangerouslySetInnerHTML={{__html:fields[field].title}}></div>{input}<button className="field-group-add-button" onClick={(e)=>{this.addObject(uri+field)}} dangerouslySetInnerHTML={{__html:fields[field].addElement}}></button></div>)

              }else{
                input = (<div key={uuidv4()} className="field" id={(uri + field).replaceAll(".","-")} order={indexInList}><div key={uuidv4()} className='field-title'>{(fields[field].type === "date")&&<i className="lni lni-calendar field-calendar-icon"></i>}{fields[field].title}</div><div className='field-errors'></div>{input}</div>)
                
                this.validateInputs[uri + field] = {field:fields[field],value:fields[field].value}
                
                if(typeof fields[field].validators !== "undefined" && fields[field].validators.includes("required"))
                  this.progressInput[uri + field] = (fields[field].value.length > 0)?true:false;
              }
              if(input !== null)
                  results.push(input)

            }else if(fields[field].type === "group"){

              var nestedObject = this.loopthroughfields(fields[field],uri+`${field}.`);
              if (nestedObject.length > 0) results.push(nestedObject);

            }else
              continue;
          }else if(field === "values" || !isNaN(field)){
            var nestedObject = this.loopthroughfields(fields[field],uri+`${field}.`);
            if (nestedObject.length > 0) 
              results.push((!isNaN(field))?(<div key={uuidv4()} className="field-group-item">{nestedObject}<button className="field-group-remove-button" onClick={(e)=>{this.removeObject(uri.slice(0,-1),field)}}><i className="lni lni-trash-can"></i></button></div>):nestedObject);
          }else{
            continue;
          } 
        }else
          continue;
      }else
        continue;
    }
    return _.flattenDeep(results);
  }
  shouldComponentUpdate(nextProps, nextState){
  
    if(this.needUiUpdate === true)
      return true;
    return false;
  }
  render() {
    this.progressInput = [];
    this.validateInputs = [];
    this.fields = _.chain(this.loopthroughfields(this.props.fields)).sortBy(elem=>elem.props.order).value();
    //console.log(this.progressInput)
    if(typeof this.props.onProgress !== "undefined")
      this.props.onProgress(this.progressInput);

    return (
      <div className='fields'>
        {/* <h1>Fields</h1> */}
        {this.fields}
        <button className="button" onClick={(e)=>{this.validateAll()}}>{this.props.submitText}</button>
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
    fields:state.fields
});
const mapDispatchToProps = (dispatch) => ({
  setField:(action)=>{dispatch(setFieldData(action))},
  quoteIfCan: () => dispatch(quoteIfCan()),
  addObject: (object) => dispatch(addObject({objectPath:object})),
  removeLastObject: (object) => dispatch(removeLastObject({objectPath:object})),
  removeObjectAt: (object,index) => dispatch(removeObjectAt({objectPath:object,index:index}))
})
export default connect(mapStateToProps,mapDispatchToProps)(Fields)